import { Button } from 'primereact/button';
import { useEffect, useState, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Toast, ToastMessage } from 'primereact/toast';
import { useTranslation } from 'react-i18next';
import ComplaintService from "../../services/complaintStatus/status";

interface ComplaintStatus {
  Name: string;
  description: string;
}
 
const StatusSearch: React.FC <{onSearch: (keyword:string) => void}> = ({ onSearch }) => {
  const { t } = useTranslation();
  const [showAddStatusModal, setShowAddStatusModal] = useState(false);
  const [name, setName] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [nameError, validateError] = useState<string>('');
  const toast = useRef<Toast>(null);
  const [selectedKeyword, setSelectedKeyword] = useState<string>('');
  const [complaintStatuses, setComplaintStatuses] = useState<ComplaintStatus[]>([]);
  const [filteredComplaintStatuses, setFilteredComplaintStatuses] = useState<ComplaintStatus[]>([]);
 
  const showMessage = (
    label: string,
    message: string,
    severity: ToastMessage['severity']
  ) => {
    toast.current?.show({
      severity: severity,
      summary: label,
      detail: message,
      life: 3000,
    });
  };
 
  const handleSearch = () => {
    onSearch(selectedKeyword);
  };

  const resetSearchFields = () => {
    setSelectedKeyword('');
    onSearch(''); 
  };

  const handleOnSuccess = async () => {
  const trimmedName = name.trim();

    if (!name.trim()) {
      validateError('Name is required.');
      return;
    }
  validateError('');
  const isDuplicate = complaintStatuses.some(
    (status) => status.Name.trim().toLowerCase() === trimmedName.toLowerCase()
  );

  if (isDuplicate) {
    showMessage('Duplicate Entry', 'Status name already exists!', 'warn');
    return;
  }
    const newStatus = {
      Name: name,
      Description: description,
    };

    try {
      const response = await ComplaintService.addStatus(newStatus);
      if(response.isSuccess){
        showMessage('Add Status', 'Status added successfully', 'success');
        window.location.reload();
        setShowAddStatusModal(false);
        setName('');
        setDescription('');
    } else {
      if (response.message === "Complaint status with this name already exists.") {
        showMessage('Duplicate Entry', response.message, 'warn');
      } else {
        showMessage('Add Status', 'Failed to add status.', 'error');
      }
      }
    } catch (error) {
      console.error("Error fetching statuses:", error);
    }

  };
 
  const handleCloseModal = () => {
    setShowAddStatusModal(false);
    setName('');
    setDescription('');
    validateError('');
  };
 
  return (
    <div className="col-12">
      <div className="card border-noround p-2" style={{ minHeight: '3.5rem' }}>
        <div className="input-container font-bold text-white border-round" style={{ float: 'left', width: '18%' }}>
          <div className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              type="search"
              value={selectedKeyword}
              onChange={(e) => setSelectedKeyword(e.target.value)}
              placeholder="Keyword Search"
              style={{ width: '100%' }}
            />
          </div>
        </div>
 
        <div className="buttons-container">
          <div className="filter-button font-bold text-white border-round" style={{ float: 'left', textAlign: 'right', width: '10%' }}>
            <Button className="text-black border-round" style={{ width: '100%', textAlign: 'center' }} onClick={handleSearch} severity="success">
              Filter
            </Button>
          </div>
          <div className="filter-button font-bold text-white border-round ml-2" style={{ float: 'left', textAlign: 'right', width: '10%' }}>
            <Button className="text-black border-round" style={{ width: '100%', textAlign: 'center' }}  onClick={resetSearchFields} severity="secondary" text raised>
              Reset
            </Button>
          </div>
          <div className="add-button-container border-round font-bold ml-3 text-primary" style={{ textAlign: 'right' }}>
            <Button
              className="bg-blue-700 border-round p-button p-button-text p-component text-center text-white"
              style={{ textAlign: 'center' }}
              onClick={() => setShowAddStatusModal(true)}
              severity="secondary"
              text
              raised
            >
              Add Complaint Status
            </Button>
          </div>
        </div>
      </div>
 
      <Dialog
        visible={showAddStatusModal}
        className="quickview w-50"
        breakpoints={{ '960px': '75vw', '641px': '90vw' }}
        modal
        onHide={handleCloseModal}
      >
<h5 className="border-round mb-3 order-top-color p-2 panel-header-text text-center">ADD COMPLAINT STATUS</h5> 
        <div className="flex flex-wrap">
          <div className="w-full mb-3 px-3">
            <div className="field">
              <label htmlFor="name" className="label-semi-bold">
                Status<span className="required">*</span>
              </label>
              <InputText
                type="text"
                id="name"
                name="name"
                placeholder="Name"
                style={{ width: '100%' }}
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  if (e.target.value.trim()) {
                    validateError('');  
                  }
                }}
              />
              {nameError && <small className="p-error">{nameError}</small>}
            </div>
          </div>
          <div className="w-full mb-3 px-3">
            <div className="field">
              <label htmlFor="description" className="label-semi-bold">
                Description
              </label>
              <InputTextarea
                autoResize
                id="description"
                name="description"
                placeholder="Description"
                rows={4}
                cols={30}
                style={{ width: '100%' }}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>
        </div>
 
        <div className="text-right mt-4">
          <Button className="bg-green-700 text-white p-button p-button-text p-component" onClick={handleOnSuccess}>
            Save
          </Button>
        </div>
      </Dialog>
 
      <Toast ref={toast} />
    </div>
  );
};
 
export default StatusSearch;